export default __webpack_public_path__ + "static/media/Wreath of the Unruly.a83fce11.jpg";